module.exports = __webpack_public_path__ + "static/media/complexPic1.2c98e52c.png";